import EncrptionInterceptor from "../lib/encryptionInterceptor";

const BASE_URL = "querymanager/insurance/web-requests";
const api = EncrptionInterceptor();

// Routed through kawachgateway_mw -> insurancex_mw (same public,
// unauthenticated path as createWebRequest/verifyCaptcha) instead of the old
// external Finsight OTP gateway — see
// insurancex_mw/src/controllers/webRequestController.js#sendOtp.
// Sent with the common headers (bearerData, urn, clientid...) and an
// encrypted body via EncrptionInterceptor.
export async function sendOTP(mobile) {
    const response = await api.post(`${BASE_URL}/send-otp`, { channel: "MOBILE", mobile });
    return response.data;
}

// name is optional — used for the verification email's {{USER_NAME}}
// (webRequestController.js#sendOtpEmail); falls back to "Customer" server-
// side when the customer hasn't filled in the Name field yet.
export async function sendEmailOTP(email, name) {
    const response = await api.post(`${BASE_URL}/send-otp`, { channel: "EMAIL", email, name });
    return response.data;
}
